module.exports = __webpack_public_path__ + "static/media/starter-desktop.2c0beef3.svg";